export const reports = {
	header: {
		title: "Reservation reports",
		description: "View reservation performance for the selected period",
		selectDate: "Select date",
		filterBySalon: "Filter by room",
	},
	salons: {
		all: "All rooms",
		main: "Main Room",
		vip: "VIP Room",
	},
	metrics: {
		totalTables: "Total tables",
		totalPeople: "Total people",
	},
	charts: {
		generalFlow: {
			title: "General flow",
			tooltip: "Chart showing the flow of reservations over the selected period",
		},
		statusPie: {
			title: "Reservations by status",
			tooltip:
				"Percentage distribution of reservations by status (Accommodated, Canceled, No-show)",
		},
		weekDayFlow: {
			title: "Flow by day of week",
			bestDay: "is your best day",
		},
		averagePeople: {
			title: "Average people per table",
			tooltip: "Average people per table in different ranges",
		},
	},
};
